// src/config/workerPackTemplates.js

const PACK_TEMPLATES = [
    {
        template_id: 890233,
        pack_name: 'RANCH$ Token Pack',
        img: require('../assets/pack/Ranch_pack.webp'),
        content_token: '1200.0000 RANCH'
    },
    {
        template_id: 890234,
        pack_name: 'FARM$ Token Pack',
        img: require('../assets/pack/Farm_pack.webp'),
        content_token: '2400.0000 FARM'
    },
    {
        template_id: 890235,
        pack_name: 'TOOL$ Token Pack',
        img: require('../assets/pack/Tool_pack.webp'),
        content_token: '2000.0000 TOOL'
    },
    {
        template_id: 890236,
        pack_name: 'RANCH$ Small Token Pack',
        img: require('../assets/pack/Small_ranch_pack.webp'),
        content_token: '600.0000 RANCH'
    },
    {
        template_id: 890237,
        pack_name: 'FARM$ Small Token Pack',
        img: require('../assets/pack/Small_farm_pack.webp'),
        content_token: '1400.0000 FARM'
    },
    {
        template_id: 890238,
        pack_name: 'TOOL$ Small Token Pack',
        img: require('../assets/pack/Small_tool_pack.webp'),
        content_token: '600.0000 TOOL'
    },
    {
        template_id: 890239,
        pack_name: 'RCOIN$ Rancher Coin Pack',
        img: require('../assets/pack/Rcoin_pack.webp'),
        content_token: '20.0000 RCOIN'
    },
    {
        template_id: 890240,
        pack_name: 'Rancher Pack',
        img: require('../assets/pack/Rancher_pack.webp'),
    },
    {
        template_id: 890241,
        pack_name: 'Farmer Pack',
        img: require('../assets/pack/Farmer_pack.webp'),
    },
    {
        template_id: 890242,
        pack_name: 'Token Pack',
        img: require('../assets/pack/Token_pack.webp'),
    },
    {
        template_id: 890243,
        pack_name: 'Lucky Clover Pack',
        img: require('../assets/pack/Lucky_clover_pack.webp'),
    },
    {
        template_id: 890244,
        pack_name: 'Worker Pack',
        img: require('../assets/pack/Worker_pack.webp'),
    },
    {
        template_id: 890245,
        pack_name: 'Starter Pack',
        img: require('../assets/pack/Starter_pack.webp'),
    },
    {
        template_id: 890246,
        pack_name: 'Bully\'s Bounty',
        img: require('../assets/pack/Bullys_bounty_pack.webp'),
    }
];

export default PACK_TEMPLATES;
